import { render, staticRenderFns } from "./VisitsFormPatientPopup.vue?vue&type=template&id=57c2babf&"
import script from "./VisitsFormPatientPopup.vue?vue&type=script&lang=js&"
export * from "./VisitsFormPatientPopup.vue?vue&type=script&lang=js&"
import style0 from "./VisitsFormPatientPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports